import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

const state = {
  screenWidth: 0,
};

const mutations = {
  CHANGEWidth(state, width) {
    state.screenWidth = width;
  },
};

const plugins = [
  createPersistedState({
    storage: {
      getItem: key => localStorage.getItem(key),
      setItem: (key, value) => localStorage.setItem(key, value),
      removeItem: key => localStorage.removeItem(key),
    },
  }),
];

export default new Vuex.Store({
  state,
  mutations,
  plugins,
});